import { render, staticRenderFns } from "./PageTabs.vue?vue&type=template&id=27491b80&scoped=true&"
import script from "./PageTabs.vue?vue&type=script&lang=ts&"
export * from "./PageTabs.vue?vue&type=script&lang=ts&"
import style0 from "./PageTabs.vue?vue&type=style&index=0&id=27491b80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27491b80",
  null
  
)

export default component.exports